module.exports = __webpack_public_path__ + "static/satan-blocker-7d0ba171f8ab0989dc96828dada32db4.png";